import React from 'react';

// sde19: All the static constant we keep in this file
// Mode in which Application is launched
export const IS_MODE = 'web';

export const COURSE_LAUNCH_TYPE = 1;
export const LCO_LAUNCH_TYPE = 2;

export const LIST_TEMPLATE = 1;
export const LAUNCHER_TEMPLATE = 2;


//
export const _REQUEST_LICENSE = 1;
export const _REQUEST_LICENSE_ACEESS_MODERATED = 2;
export const _LICENSE_PENDING = 3;
export const _INSUFFICIENT_LICENSE = 4;
export const _START = 5;
export const _RESUME = 6;

// Content Types
export const COMPANION_FORMAT = 'lco';
export const SCORM_FORMAT = 'sco';
export const VIDEO_FORMAT = 'video';
export const PDF_FORMAT = 'pdf';
export const IMAGE_FORMAT = 'image';
export const UNKNOWN_FORMAT = 'unknown';
export const LINK_FORMAT = 'link';

// Error Types
export const EXCP_ERROR = 'Error';
export const LP_EXCP_ERROR = 'LP_EXCP_ERROR';
export const ERR_WARNING = 'Warning';
export const ERR_INFO = 'Info';

// SCORM APIs
export const SCORM_IS_RUNNING = 'IsRunning';
export const SCORM_INITIALIZE = 'Initialize';
export const SCORM_GET_VALUE = 'GetValue';
export const SCORM_SET_VALUE = 'SetValue';
export const SCORM2004_SET_VALUE = 'SCORM2004_CallSetValue';
export const SCORM_COMMIT = 'Commit';
export const SCORM_TERMINATE = 'Terminate';
export const SCORM_IS_READ_ONLY = 'IsReadOnly';
export const SCORM_IS_WRITE_ONLY = 'IsWriteOnly';
export const SCORM_GET_LAST_ERROR = 'GetLastError';
export const SCORM_GET_DIAGNOSTIC = 'GetDiagnostic';
export const SCORM_GET_ERROR_STRING = 'GetErrorString';
export const SCORM_CREATE_REQUEST = 'createRequest';
export const SCORM_GET_BASE_URL = 'getBaseUrl';

// SCORM Variables
export const CMI_PROGRESS_MEASURE = 'cmi.progress_measure';
export const CMI_SCORE_SCALED = 'cmi.score.scaled';
export const CMI_SUCCESS_STATUS = 'cmi.success_status';
export const CMI_COMPLETION_STATUS = 'cmi.completion_status';
export const CMI_SUSPEND_DATA = 'cmi.suspend_data';

// Launcher Status
export const LAUNCHER_NOT_STARTED = 'Not started';
export const LAUNCHER_INCOMPLETE = 'Incomplete';
export const LAUNCHER_IN_PROGRESS = 'In Progress';
export const LAUNCHER_COMPLETED = 'Completed';
export const LAUNCHER_NOT_ATTEMPTED = 'Not attempted';
export const LAUNCHER_PASSED = 'Passed';
export const LAUNCHER_FAILED = 'Failed';

// CLS Status
export const CLS_NOT_STARTED = 'not_started';
export const CLS_INCOMPLETE = 'incomplete';
export const CLS_IN_PROGRESS = 'In Progress';
export const CLS_COMPLETED = 'completed';
export const CLS_NOT_ATTEMPTED_1 = 'not attempted';
export const CLS_NOT_ATTEMPTED_2 = 'not_attempted';
export const CLS_PASSED = 'passed';
export const CLS_FAILED = 'failed';

// SCORM Status
export const SCORM_NOT_STARTED = 'not_started';
export const SCORM_STATUS_COMPLETED = 'completed';
export const SCORM_STATUS_NOT_ATTEMPTED = 'not_attempted';
export const SCORM_STATUS_INCOMPLETE = 'incomplete';
export const SCORM_STATUS_UNKNOWN = 'unknown';
export const SCORM_STATUS_PASSED = 'passed';
export const SCORM_STATUS_FAILED = 'failed';
export const SCORM_STATUS_NOT_STARTED = 'unknown';

// cmplSts in integer
export const _NOT_ATTEMPTED = 0;
export const _INCOMPLETE = 1;
export const _COMPLETED = 2;
export const _PASSED = 3;
export const _FAILED = 4;
export const _NOT_ATTEMPTED_TEST = 6;
export const _ENROLLED = 7;

// Launched From
export const LEX_SELF_LAUNCHED = 0;
export const LEX_LAUNCHED_FROM_LP = 1;

// SUPPORTED LINK
export const YOUT_LINK = 'youtube.com';
export const YOUT_EMBD_STR = '/embed/';

export const LEX_TYPE_FOR_COURSE = 1;
export const LEX_TYPE_FOR_LCO = 2;
export const LEX_TYPE_FOR_CERTIFICATE = 3;
export const LEX_TYPE_FOR_LP = 4;
export const LEX_TYPE_FOR_ASSESSMENT = 5;

export const LEX_COURSE_TYPE = 1;
export const LEX_ASSESSMENT_TYPE = 2;

export const aTy_REQUEST_FROM_PLATFORM = '1';

// Lex exam status
export const LEX_KRY_TAKE_EXAM = 1;
export const LEX_KRY_RESUME_EXAM = 2;
export const LEX_KRY_RETAKE_EXAM = 3;
export const LEX_KRY_EXAM_PASSED = 4;
export const LEX_KRY_EXAM_NOT_PASSPORT = 5;
export const LEX_KRY_RES_PASS = 'pass';
export const LEX_KRY_RES_NA = 'NA';
export const LEX_KRY_MAX_ATTEMPT = 2;
export const LEX_KRY_FREEZED_DAYS = 14;

export const LOC_URL_UNAUTHORIZED = '/CompanionManager/up/static/page/unauthorized.html';

export const getContentIconByType = (cType) => {
    switch (cType) {
        case 'Lesson':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_lesson.svg' />);
        case 'Test':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_test.svg' />);
        case 'Course':
            return (<img className="content-icon-tab-view" src='static/images/lex/course_ctype_icon.svg' />);
        case 'Learning Path':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_regular.svg' />);
        case 'Exercise':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_exercise.svg' />);
        case 'Image':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_image.svg' />);
        case 'Video':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_video.svg' />);
        case 'Link':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_link.svg' />);
        case 'Pdf':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_pdf.svg' />);
        case 'Audio':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_audio.svg' />);
        case 'Other':
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_other.svg' />);
        case 'Learning Module':
            return (<img className="content-icon-tab-view" src='static/images/lex/course_ctype_icon.svg' />);
        case 'Certification':
            return (<img className="content-icon-tab-view" src='static/images/lex/certi_ctype_icon.svg' />);
        default:
            return (<img className="content-icon-tab-view" src='static/images/lex/lco_other.svg' />);
    }
};

export const getSeparatorByType = (type, height) => {
    switch (type) {
        case 1:
            return (<div style={{height: height}} className='separator crs-separator'></div>);
        case 2:
            return (<div style={{height: height}} className='separator lco-separator'></div>);
        case 3:
            return (<div style={{height: height}} className='separator cert-separator'></div>);
        case 4:
            return (<div style={{height: height}} className="separator lp-separator"></div>);
        default:
            return null;
    }
};

export const getRoleIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img src="static/images/lex/course_ctype_icon.svg" />);
        case 2:
            return (<img src="static/images/lex/learning_obj_icon.svg" />);
        case 3:
            return (<img src="static/images/lex/certi_obj_icon.svg" />);
        case 4:
            return (<img src="static/images/lex/lp_role_icon.svg" />);
        default:
            return null;
    }
};

export const getRoleByType = (type, lexExpcType) => {
    switch (type) {
        case 1:
            return (<span className= "role-mobile-view role-view" style={{color: '#dbac00'}}>Learning Module</span>);
        case 2:
            return (<span className= "role-mobile-view role-view" style={{color: '#816c61'}}>Lesson</span>);
        case 3:
            return (<span className= "role-mobile-view role-view" style={{color: '#bf4f9f'}}>Certification</span>);
        case 4:
            return (<span className= "role-mobile-view role-view" style={{color: '#35b4ff'}}>{lexExpcType}</span>);
        default:
            return ('');
    }
};

export const getPosterBgClassName = (type) => {
    switch (type) {
        case 1:
            return 'crs-poster-bg';
        case 3:
            return 'cert-poster-bg';
        case 4:
            return 'lp-poster-bg';
        default:
            return ('');
    }
};

export const getDurationIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img src="static/images/lex/lm_duration_icon.svg" />);
        case 3:
            return (<img src="static/images/lex/cert_duration_icon.svg" />);
        case 4:
            return (<img src="static/images/lex/lp_duration_icon.svg" />);
        default:
            return ('');
    }
};

export const getNoOfContentIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img src="static/images/lex/lm_num_of_cont_icon.svg" />);
        case 4:
            return (<img src="static/images/lex/lp_num_of_cont_icon.svg" />);
        default:
            return ('');
    }
};

export const getIndustryIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img src="static/images/lex/lm_inds_icon.svg" />);
        case 3:
        case 4:
            return (<img src="static/images/lex/cert_inds_icon.svg" />);
        // case 4:
        //     return (<img src="static/images/lex/lp_inds_icon.svg" />);
        default:
            return ('');
    }
};

export const getMetaRoleIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img src="static/images/lex/lm_meta_role_icon.svg" />);
        case 3:
            return (<img src="static/images/lex/cert_meta_role_icon.svg" />);
        case 4:
            return (<img src="static/images/lex/lp_meta_role_icon.svg" />);
        default:
            return ('');
    }
};

export const getVersionIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img className="version-icon-mobile" src="static/images/lex/lm_ver_icon.svg" />);
        case 2:
            return (<img className="version-icon-mobile" src="static/images/lex/lm_ver_icon.svg" />);
        case 3:
            return (<img className="version-icon-mobile" src="static/images/lex/cert_lang_icon.svg" />);
        case 4:
            return (<img className="version-icon-mobile" src="static/images/lex/lp_ver_icon.svg" />);
        default:
            return ('');
    }
};

export const getLanguageIconByType = (type) => {
    switch (type) {
        case 1:
            return (<img className="lang-icon-mobile" src="static/images/lex/lm_lang_icon.svg" />);
        case 2:
            return (<img className="lang-icon-mobile" src="static/images/lex/lm_lang_icon.svg" />);
        case 4:
            return (<img className="lang-icon-mobile" src="static/images/lex/lp_lang_icon.svg" />);
        default:
            return ('');
    }
};

export const getMetaBrandIconByType = (type) => {
    switch (type) {
        case 3:
            return (<img className="lang-icon-mobile" src="static/images/lex/cert_brand_icon.svg" />);
        default:
            return ('');
    }
};

export const languages = {
    fr: 'French',
    de: 'German',
    ja: 'Japanese',
    es: 'Spanish',
    ko: 'Korean',
    ru: 'Russian',
    zh: 'Chinese',
    en: 'English',
    pt: 'Portuguese'
};

export const getContentLabelColorByType = (type) => {
    switch (type) {
        case 1:
            return '#dbac00';
        case 2:
            return '#816c61';
        case 3:
            return '#943b7a';
        default:
            return ('');
    }
};

export const getCardUpperBorderColorByType = (type) => {
    switch (type) {
        case 1:
            return 'rgb(220, 173, 0)';
        case 3:
            return 'rgb(161, 4, 90)';
        case 4:
            return 'rgb(35, 157, 232)';
        default:
            return ('');
    }
};

export const getIconByType = (type) => {
    switch (type) {
        case 1:
            return 'static/images/card/lmIcon.svg';
        case 3:
            return 'static/images/card/certificationIcon.svg';
        case 4:
            return 'static/images/card/lpIcon.svg';
        default:
            return ('');
    }
};

export const getCardTypeBycType = (type) => {
    switch (type) {
        case 1:
            return 'Learning Module';
        case 2:
            return 'Lesson';
        case 3:
            return 'Certification';
        case 4:
            return 'Learning Path';
        default:
            return ('');
    }
};

// Lex Certi status
export const LEX_CERT_LOGIN = 1;
export const LEX_CERT_ENROLL = 2;
export const LEX_CERT_TAKE_EXAM = 3;
export const LEX_CERT_RESUME_EXAM = 4;
export const LEX_CERT_CERTIFIED = 5;
export const LEX_CERT_WAIT = 6;
export const LEX_CERTI_ENROLL = 8;
